<div class="container" [class.disabled]="disabled" (click)="!disabled && onChange()">
  <img src="../../assets/images/checkbox{{getValue() ? '-selected' : ''}}{{disabled ? '-disabled' : ''}}.svg">
  <span>{{label}}</span>
</div>
<div *ngIf="error" [ngSwitch]="error" class="error-message">
  <span class="icon-error"></span>
  <ng-container *ngSwitchCase="'required'" i18n>This field is required</ng-container>
  <ng-container *ngSwitchDefault i18n>Invalid field</ng-container>
</div>
